/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getIncidentFileFieldTypeByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetIncidentFileFieldTypeById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getIncidentFileFieldTypeByIdIdRegExpTwo)]).optional()
});

export type GetIncidentFileFieldTypeById = zod.input<typeof GetIncidentFileFieldTypeById>;
export type GetIncidentFileFieldTypeByIdOutput = zod.output<typeof GetIncidentFileFieldTypeById>;
